const monsters = require('../data/monsters.json');
const soldiers = require('../data/soldiers.json');
const traits = require('../data/traits.json');
const potions = require('../data/potions.json');
const greatPotions = require('../data/greatPotions.json');
const magicItems = require('../data/magicItems.json');

const breedingPitsItems = require('../data/item_breeding_pits.json');
const fireheartConstructModsItems = require('../data/item_fireheart_constructs_mods.json');
const fireHeartItems = require('../data/item_fireheart.json');
const linchKingItems = require('../data/item_linch_king.json');
const redKingItems = require('../data/item_redking.json');
const bloodLegacyItems = require('../data/item_blood_legacy.json');
const forgottenPactItems = require('../data/item_forgotten_pacts.json');
const magicWeaponsAndArmor = require('../data/magicWeaponsArmor.json');
const spells = require('../data/spells.json');
const baseType = require('../data/basesTypes.json');
const baseUpgrades = require('../data/basesUpgrades.json');
const wildwoodsMIItems = require('../data/item_wildwoods_magic_item.json');
const wildwoodsMAItems = require('../data/item_wildwoods_magic_wa.json');
const mazeMalcorItems = require('../data/item_maze_malcor.json');

export function getMonsters() {
  let parsedMonsters = parseThreatLevel(monsters);
  for (let index = 0; index < parsedMonsters.length; index++) {
    const mons = parsedMonsters[index];
    mons.Threat_level = Math.round(mons.Threat_level * 100) / 100;
  }
  return parsedMonsters.filter((monster) => monster.Status === 'READY');
}

export function removeParentheses(str) {
  // Find the index of the first opening parenthesis
  const index = str.indexOf('(');

  // If a parenthesis is found, return the substring before it
  if (index !== -1) {
    return str.substring(0, index);
  }

  // If no parenthesis is found, return the original string
  return str;
}

export function getSpells() {
  return spells;
}

export function getMagicItems({
  core = true,
  breedingPits = true,
  fireheartConstructMods = true,
  fireHeart = true,
  linchKing = true,
  redKing = true,
  bloodLegacy = true,
  forgottenPact = true,
  wildwoodsMA = true,
  wildwoodsMI = true,
  mazeMalcor = true,
} = {}) {
  let item = [];

  if (core) {
    item.push(...magicItems);
  }

  if (breedingPits) {
    item.push(...breedingPitsItems);
  }
  if (fireheartConstructMods) {
    item.push(...fireheartConstructModsItems);
  }
  if (fireHeart) {
    item.push(...fireHeartItems);
  }
  if (linchKing) {
    item.push(...linchKingItems);
  }
  if (redKing) {
    item.push(...redKingItems);
  }

  if (bloodLegacy) {
    item.push(...bloodLegacyItems);
  }

  if (forgottenPact) {
    item.push(...forgottenPactItems);
  }

  if (wildwoodsMA) {
    item.push(...wildwoodsMAItems);
  }

  if (wildwoodsMI) {
    item.push(...wildwoodsMIItems);
  }

  if (mazeMalcor) {
    item.push(...mazeMalcorItems);
  }

  item = item.sort((a, b) => {
    if (a.item < b.item) return -1;
    if (a.item > b.item) return 1;
    return 0;
  });

  return item;
}

export function getMagicWeaponsAndArmor({ core = true, wildwoodsMA = true } = {}) {
  console.log({ wildwoodsMA, core });
  let item = [];

  if (core) {
    item.push(...magicWeaponsAndArmor);
  }

  if (wildwoodsMA) {
    item.push(...wildwoodsMAItems);
  }

  item = item.sort((a, b) => {
    if (a.item < b.item) return -1;
    if (a.item > b.item) return 1;
    return 0;
  });

  return item;
}
export function getTraits() {
  return traits;
}
export function getPotions() {
  return potions;
}

export function getGreatPotions() {
  return greatPotions;
}

export function getSoldiers() {
  return soldiers;
}

export function getBaseType() {
  return baseType;
}

export function getBaseUpgrades() {
  return baseUpgrades.sort((a, b) => {
    if (a.resource < b.resource) return -1;
    if (a.resource > b.resource) return 1;
    return 0;
  });
}

export function getRandomThreat({ minParam, maxParam }) {
  let min = parseInt(minParam + '');
  let max = parseInt(maxParam + '');
  let val = Math.floor(min + Math.random() * (max - min + 1));
  console.log(min, max, val);
  return val;
}

function parseThreatLevel(monsters) {
  return monsters.map((monster) => ({
    ...monster,
    Threat_level: Number(monster.Threat_level),
  }));
}

export function findTraits(traitFromCreature) {
  return traits.filter((trait) => removeParentheses(trait.name).trim() === removeParentheses(traitFromCreature).trim());
}
